import React from 'react';

const SidebarDOC = (props) => {
    return (
        <div>
        {props.doc.properties.map((item,index)=>{
            return (
                <div>
                    <b>{item.label}: <i>&nbsp; &nbsp; &nbsp; {item.value} </i> </b>
                    <br/><br/>
                    <div>{item.description}</div>
                    <br/><br/>
                </div>
            )
        })}
        </div>
    )
}


export default SidebarDOC


// WEBPACK FOOTER //
// ./src/samples/SidebarHomeDOC.js